<template>
  <div>
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-50 flex items-center justify-center mt-5 overflow-x-hidden overflow-y-auto outline-none md:mt-5 focus:outline-none"
    >
      <div class="relative w-[45rem] h-full p-4 md:h-auto">
        <div class="relative bg-white shadow rounded-xl">
          <div class="flex items-center justify-between px-2 py-4">
            <p class="pl-2 font-medium text-black">Report this Property</p>
            <button
              type="button"
              class="absolute right-0 flex items-center justify-center p-1 ml-auto text-sm font-thin text-black bg-transparent bg-gray-200 rounded-full w-14 hover:text-gray-900"
              @click="closeViewModal()"
              data-modal-toggle="show-login-modal"
            >
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <hr />

          <div class="flex md:flex-row md:h-[25rem] flex-col">
            <div
              class="flex flex-col items-center justify-center p-4 md:w-6/12 bg-stone-50"
            >
              <img
                src="@/assets/images/account.svg"
                class="mx-auto w-28 h-28"
                alt=""
              />
              <p
                class="flex items-center justify-center mt-5 text-sm font-light text-center text-gray-500"
              >
                Sorry to hear there is a problem with this property. Please
                provide more details to solve this issue.
              </p>
            </div>
            <div
              class="flex flex-col items-center justify-center p-6 space-y-5 md:w-6/12"
            >
              <p
                v-show="alert_message"
                class="text-sm font-semibold text-center text-teal-600"
              >
                {{ alert_message }}
              </p>
              <select
                class="w-full p-2 text-sm text-black bg-white border border-gray-400 rounded-lg h-11"
                v-model="user_type"
                id="user_type"
              >
                <option disabled selected value="">select user type</option>
                <option value="potential_renter">
                  I am a potential renter
                </option>
                <option value="owner">I am the landlord</option>
                <option value="agent">I am an agent</option>
              </select>
              <select
                class="w-full p-2 text-sm text-black bg-white border border-gray-400 rounded-lg h-11 placeholder:text-stone-400"
                v-model="reason"
                id="user_type"
              >
                <option disabled selected value="">select reason</option>
                <option value="Property not available">
                  Property not available
                </option>
                <option value="Inaccurate price">Inaccurate price</option>
                <option value="no response from broker">
                  no response from broker
                </option>
                <option value="no property details">no property details</option>
                <option value="Poor quality or irrelevant photos">
                  Poor quality or irrelevant photos
                </option>
                <option value="Inaccurate location">Inaccurate location</option>
                <option value="Inaccurate number of beds">
                  Inaccurate number of beds
                </option>
                <option value="Inaccurate property type">
                  Inaccurate property type
                </option>
              </select>
              <textarea
                placeholder="type your message here..."
                class="w-full p-2 text-sm border border-gray-400 rounded-lg placeholder:text-stone-400"
                id="login_password"
                cols="6"
                rows="4"
                v-model="message"
              ></textarea>
              <button
                @click="sendReport"
                class="w-full p-3 mt-5 font-semibold text-white rounded-lg hover:bg-primary bg-secondary"
              >
                Send Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-40 bg-black opacity-25"
    ></div>
  </div>
</template>

<script setup>
import axios from "axios";
import { getCurrentInstance, defineProps, ref } from "vue";
import { useStore } from "vuex";

const { emit } = getCurrentInstance();
const props = defineProps({
  showViewModal: Boolean,
  property_id: Number,
  user_id: {
    type: [Number, String],
    required: false,
  },
});

const store = useStore();
const base_url = store.state.baseUrl;
const user_type = ref("");
const reason = ref("");
const message = ref("");
const alert_message = ref("");

const closeViewModal = () => {
  emit("closeViewModal");
};
const sendReport = async () => {
  try {
    const response = await axios.post(`${base_url}property-report`, {
      user_id: props.user_id,
      property_id: props.property_id,
      user_type: user_type.value,
      reason: reason.value,
      description: message.value,
    });
    setTimeout(() => {
      alert_message.value = response.data.message;
      closeViewModal();
    }, 1000);
  } catch (error) {
    console.error("Error sending report", error);
    // Handle the error, e.g., show an error message
  }
};
</script>
<style scoped>
.text-green-500 {
  color: #10b981; /* Tailwind green-500 */
}
.text-red-500 {
  color: #ef4444; /* Tailwind red-500 */
}
</style>
